import type { Capture } from "./schema";

// Perf accueil (mémo CaptureRow, 22-07) : un fetch réseau produit toujours de
// NOUVEAUX objets, même quand rien n'a changé côté serveur. Comparaison
// structurelle simple — sûre ici car `Capture` (via `parseCapture`/zod) est
// toujours JSON-sérialisable (que des primitives + objets/tableaux imbriqués
// plats, jamais de fonction ni d'instance Date) et produit un ordre de clés
// STABLE (zod construit la sortie dans l'ordre du schéma, pas celui de
// l'entrée) : deux captures identiques sérialisent donc à l'identique.
function capturesEqual(a: Capture, b: Capture): boolean {
  return a === b || JSON.stringify(a) === JSON.stringify(b);
}

// Réutilise la RÉFÉRENCE de la capture précédente quand son contenu n'a pas
// changé : indispensable pour que React.memo(CaptureRow) (comparaison shallow
// par défaut) bail-out sur un tick de poll qui ne change rien. Sans ça,
// `capture` serait une référence neuve à CHAQUE fetch et la mémoïsation de la
// rangée serait inutile (elle re-rendrait à chaque tick malgré memo).
export function reconcileCaptures(prev: readonly Capture[], next: readonly Capture[]): Capture[] {
  if (prev.length === 0) return [...next];
  const prevById = new Map(prev.map((c) => [c.id, c]));
  return next.map((c) => {
    const old = prevById.get(c.id);
    return old && capturesEqual(old, c) ? old : c;
  });
}
